import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module';
import { CommonService } from 'src/app/core/services/common.service';
import { BaseComponent } from '../base/base.component';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-menu-link',
  templateUrl: './menu-link.component.html',
  styleUrls: ['./menu-link.component.less'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CoreModule]
})
export class MenuLinkComponent extends BaseComponent implements OnChanges, OnInit {
  @Input() navigationItem: any;
  @Input() activeItem: any;
  @Input() public linkClass = 'no-decoration menu-link';
  @Output() megaMenuClosed = new EventEmitter<void>();
  selectedChildMenuItem: any;
  isDesktopUp = true;
  isBrowser = false;
  linkType = '';
  constructor(public commonService: CommonService) {
    super()
  }

  ngOnInit(): void {
    this.isBrowser = this.commonService.isPlatformBrowser();
    if(this.isBrowser) {
      this.commonService.desktopUp$.pipe(takeUntil(this.destroy$)).subscribe(isDesktopUp => this.isDesktopUp = isDesktopUp);
    }
  }

  ngOnChanges(): void {
  const nav = this.navigationItem?.navigation;

  if (Array.isArray(nav) && nav.length > 0) {
    this.selectedChildMenuItem = nav[0];
    const firstNav = nav[0];

    if (firstNav?.internalLink?.url) {
      this.linkType = 'internal-link';
    } else if (firstNav?.externalLink) {
      this.linkType = 'external-link';
    } else {
      this.linkType = '';
    }
  } else {
    this.selectedChildMenuItem = null;
    this.linkType = 'jump-link';
  }
}

  selectSubMenu(event: any, menuItem: any) {
    event.stopPropagation();
    event.preventDefault();
    this.selectedChildMenuItem = menuItem;
  }

  handleInsideClick(event: any) {
    if (event.target.tagName.toLowerCase() !== 'a' && event.target.parentNode?.nodeName.toLowerCase() !== 'a') {
      event.stopPropagation()
    }
  }

  close(event) {
    if(this.commonService.a11yClick(event)) {
      this.activeItem = ''
      this.megaMenuClosed.emit();
      event.stopPropagation();
      this.selectedChildMenuItem = null;
    }
  }

  trackByUniqueId(index: number, menuitem: any): any {
    let id = menuitem?.titleInternal || menuitem?.title
    id = id ? id.replace(/\s+/g, '-').toLowerCase() + index.toString() : index.toString();
    return id;
  }
}
